import { Component, OnInit, Input } from '@angular/core';
import { Bracket, BracketRound, TournamentTeam, DataService } from 'src/app/services/data-service.service';

@Component({
  selector: 'elimination-round',
  templateUrl: './elimination-round.component.html',
  styleUrls: ['./elimination-round.component.scss']
})
export class EliminationRoundComponent implements OnInit {
  @Input() bracket: Bracket;
  @Input() round: BracketRound;

  public teamsWithByes: TournamentTeam[] = [];

  constructor(public ds: DataService) { }

  ngOnInit(): void {
    this.teamsWithByes = this.ds.currentTournament.teams.filter(t => t.eliminationBye && t.bracketId === this.bracket.id);
    this.round.matches[0].showHeaders = true;
  }
}
